import { BaseSyntheticEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { FieldValues } from 'react-hook-form';
import { useAPIWrapper } from 'drf-react-by-schema';

import { useAppSelector } from '../app/hooks';

export const useFormSubmit = () => {
  const navigate = useNavigate();
  const { onSubmit, setPageForm, updateUsuaria } = useAPIWrapper();
  const { perfil, model, id, submitSuccessTarget } = useAppSelector((state) => state.page);

  const onLocalSubmit = async (
    data: FieldValues,
    event?: BaseSyntheticEvent<object, object, object>
  ) => {
    if (!model || !onSubmit || !setPageForm || !perfil) {
      console.error('Missing required dependencies for form submission');
      return;
    }

    // onSubmit returns false on failure and the id of the object created/updated on success
    const response = (await onSubmit(model, id, data, event)) as false | string | number;

    if (response !== false) {
      // reset pageForm and exit (navigate)
      setPageForm({
        id: undefined,
        schema: null,
        columns: undefined,
        initialValues: null,
        validationSchema: null,
      });

      // reload "minhaconta"
      if (model === 'perfil' && perfil.id?.toString() === id) {
        updateUsuaria();
      }

      if (!submitSuccessTarget || submitSuccessTarget === -1) {
        navigate(-1);
        return;
      }

      if (typeof submitSuccessTarget === 'string') {
        navigate(submitSuccessTarget.replace('{ID}', `${response}`));
        return;
      }

      submitSuccessTarget({ ...data, id: response });
      return;
    }
  };

  return { onLocalSubmit };
};
